import { codeItemToStoreValue } from 'app/infrastructure/data/codes';
import { parseAsDateUTC, toISODatewithoutTimezone } from 'app/infrastructure/data/date';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { ImportSetItem } from '../types-store';
import { DuplicateImportSetItemWire, ImportSetActionType, ImportSetItemWire } from '../types';
import { textWithDuplicateSuffix } from 'app/area/import-sets-administration/form/constants';

export const mapImportSetFromWire = (wire: Partial<ImportSetItemWire>, actionType?: ImportSetActionType, locale?: string): ImportSetItem => {

  const language = wire?.language?.map(codeItemToStoreValue) ?? [];

  return {
    id: wire?.id?.v,
    description: wire?.id?.d,
    disabled: wire?.disabled
      ? parseAsDateUTC(wire.disabled)
      : undefined,
    criteriaDomain: codeItemToStoreValue(wire?.criteriaDomain),
    ...(actionType !== ImportSetActionType.duplicate && { importDatabaseId: wire?.importDatabaseId }),
    ...(wire?.importConstraintSet?.v && { importConstraintSet: codeItemToStoreValue(wire?.importConstraintSet) }),
    language: actionType !== ImportSetActionType.duplicate
      ? language
      : language
        .map(item => ({
          value: item.value,
          description: textWithDuplicateSuffix(item.description, locale)
        }))
  };
}

export const mapImportSetToWire = (importSet: ImportSetItem): ImportSetItemWire => {
  const importConstraintSet = importSet?.importConstraintSet?.value;
  return {
    ...(isDefinedIncludingZero(importSet?.importDatabaseId)
      && { importDatabaseId: importSet?.importDatabaseId }),

    disabled: importSet?.disabled
      ? toISODatewithoutTimezone(importSet.disabled)()
      : undefined,

    ...(isDefinedIncludingZero(importSet?.criteriaDomain?.value)
      && { criteriaDomain: { v: importSet?.criteriaDomain.value } }),

    importConstraintSet: { v: importConstraintSet ?? 0 },

    language: importSet?.language?.map(languageItem => ({
      v: languageItem.value,
      d: languageItem.description?.trim()
    })) ?? []
  };
};

export const mapDuplicateImportSetItemWire = (importSet: ImportSetItemWire): DuplicateImportSetItemWire => {
  const newImportSet = {
    ...importSet,
    criteriaDomain: isDefinedIncludingZero(importSet?.criteriaDomain?.v)
      ? importSet?.criteriaDomain
      : undefined
  };

  return Object.assign({},
    ...Object.keys(newImportSet).map(property => ({
      [property]: {
        ...(newImportSet[property] && { value: newImportSet[property] }),
        override: true
      }
    })));
};
